import React, { useState } from "react";
import "./style.css";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth, getUserDetails } from "../../utils/firebase-config";
import { useNavigate } from "react-router-dom";
import { SUPER_ADMIN } from "../../utils/constants";
import { Backdrop, CircularProgress } from "@mui/material";

function Login() {
  let navigate = useNavigate();
  const [backdropOpen, setBackdropOpen] = useState(false);

  const [formData, setFormData] = useState({ email: "", password: "" });
  // const [isRegistering, setIsRegistering] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    setBackdropOpen(true);
    signInWithEmailAndPassword(auth, formData.email, formData.password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        checkUserIsRegistered(user);
      })
      .catch((error) => {
        if (error.code == "auth/invalid-login-credentials") {
          window.alert(`Invalid credentials`);
        } else {
          window.alert(`Error while login user.`);
        }
        console.log(error);
        setBackdropOpen(false);
      });
  };

  async function checkUserIsRegistered(user) {
    const userDetail = await getUserDetails(formData.email);
    if (userDetail !== null) {
      setBackdropOpen(false);
      if (userDetail.type === SUPER_ADMIN) {
        console.log(userDetail);
        navigate("/view-users", { state: userDetail });
      } else {
        navigate("/detail", { state: userDetail });
      }
    } else {
      window.alert("User Not found");
    }
  }

  return (
    <div style={{ display: "inline-grid", width: "98%" }}>
      <form onSubmit={handleSubmit}>
        <div className="form-login">
          <div className="input-field">
            <label>Email</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="input-field">
            <label>Password</label>
            <input
              className="form-input"
              type={"password"}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <button className="submit-btn" type="submit">
          {"Login"}
        </button>
        {/* <p
          style={{ marginTop: "10px", cursor: "pointer" }}
          onClick={() => setIsRegistering(!isRegistering)}
        >
          {isRegistering
            ? "Already have an account? Authenticate."
            : "Don't have an account? Register."}
        </p > */}
        <div style={{ textAlign: "left" }}>
          <p
            onClick={() => {
              navigate("/reset-password");
            }}
            style={{ marginTop: "10px", cursor: "pointer" }}
          >
            Forgot password?{" "}
            <span
              style={{
                color: "var(--text-color)",
                textDecoration: "underline",
                fontStyle: "normal",
              }}
            >
              Reset
            </span>
          </p>
        </div>
        <div className="divider"></div>
        <div style={{ textAlign: "center", display: "none" }}>
          <h2 className="close-text">Registration closed.</h2>
        </div>
        <div style={{ textAlign: "right" }}>
          <p
            onClick={() => {
              navigate("/registration-type");
            }}
            style={{ cursor: "pointer" }}
          >
            Don't have an account?{" "}
            <span
              style={{
                color: "var(--text-color)",
                textDecoration: "underline",
                fontStyle: "normal",
              }}
            >
              Register
            </span>
          </p>
        </div>
      </form>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default Login;
